import styled from 'styled-components'

export const SectionTitleStyle = styled.span`
	font-size: 18px;
	font-weight: bold;
`
